<div class="switch-host" (click)="toggleEditMode()"  *ngIf="editable">
    Режим редактирования
    <switch [val]="editMode"></switch>       
</div>